export enum ShipmentMethodEnum{
    PICK_UP="PICK_UP",
    DELIVERY="DELIVERY"
}